export default "__VITE_ASSET__cr58EWGJ__"